import { ILabelProps } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { IGetConfigArgs } from './interfaces';

export const getConfig = ({
  host,
  startTime,
  endTime,
  currentBooking,
  t,
}: IGetConfigArgs): {
  labelProps: ILabelProps;
  disabled?: boolean;
} => {
  if (host.client_sessions?.length) {
    for (const session of host.client_sessions) {
      const sessionStart = dayjs(session.started_at);
      const sessionEnd = dayjs(session.finished_at);

      if (!startTime || !endTime) {
        return {
          labelProps: {
            color: 'blue',
            text: t('booking.host.session', sessionEnd.format('HH:mm')),
          },
          disabled: true,
        };
      }

      const overlaps =
        startTime.isBefore(sessionEnd) && endTime.isAfter(sessionStart);

      if (overlaps) {
        return {
          disabled: true,
          labelProps: {
            color: 'gray-primary',
            text: t('booking.host.session', sessionEnd.format('HH:mm')),
          },
        };
      }
    }

    return {
      labelProps: {
        color: 'blue',
        text: t(
          'booking.host.session',
          dayjs(host.client_sessions[0].finished_at).format('HH:mm')
        ),
      },
    };
  }

  for (const booking of host.bookings) {
    const bookingStart = dayjs(booking.from);
    const bookingEnd = dayjs(booking.to);

    if (booking.group && booking.group === currentBooking?.group) continue;
    if (currentBooking?.id === booking.id) continue;
    if (bookingEnd.isBefore(startTime)) continue;
    if (bookingEnd.isSame(startTime)) continue;

    if (bookingStart.isSame(startTime) || bookingStart.isBefore(startTime)) {
      return {
        disabled: true,
        labelProps: {
          color: 'gray-primary',
          text: t('booking.host.booked.until', bookingEnd.format('HH:mm')),
        },
      };
    }

    if (
      startTime?.isBefore(bookingStart, 'minute') &&
      endTime?.isAfter(bookingStart, 'minute')
    ) {
      return {
        disabled: true,
        labelProps: {
          color: 'gray-primary',
          text: t(
            'booking.host.booked.period',
            bookingStart.format('HH:mm'),
            bookingEnd.format('HH:mm')
          ),
        },
      };
    }

    if (bookingStart.isSame(endTime, 'day')) {
      return {
        labelProps: {
          color: 'green',
          text: t('booking.host.free.until', bookingStart.format('HH:mm')),
        },
      };
    }
  }

  return { labelProps: { color: 'green', text: t('booking.host.free') } };
};
